"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipComponent = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
const _excluded = ["width", "height", "bg", "tooltipPosition"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const TooltipComponent = exports.TooltipComponent = _styledComponents.default.div`
	${_ref => {
  let {
      width,
      height,
      bg,
      tooltipPosition
    } = _ref,
    props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  return `
      position: relative;
      display: inline-block;
      & .tooltip {
          position: absolute;
          width: ${width};
          height: ${height};
          background: ${bg}; 
          z-index: 2;
          border-radius: 10px;
          padding: 8px 16px;
          ${tooltipPosition == 'bottom' && (0, _styledComponents.css)`
					left: 50%;
					top: 100%;
					transform: translate(-50%, 12px);
				`}
          ${tooltipPosition == 'right' && (0, _styledComponents.css)`
					top: 0%;
					right: -58%;
					bottom: 0%;
				`}
          ${tooltipPosition == 'left' && (0, _styledComponents.css)`
					left: 0%;
					top: 50%;
					transform: translate(calc(-100% - 11.5px), -50%);
				`}
          ${tooltipPosition == 'top' && (0, _styledComponents.css)`
					right: 0;
					bottom: 57%;
					transform: translate(50%, calc(-100% + 12px));
				`}
      }
      &:hover:before {
          content: "";
          position:absolute;
          border:8px solid ${bg};
          ${tooltipPosition == 'left' ? 'border-color: transparent transparent transparent ' + bg + ';' : tooltipPosition == 'right' ? 'border-color: transparent  ' + bg + ' transparent transparent;' : tooltipPosition == 'top' ? 'border-color: ' + bg + ' transparent transparent transparent;' : 'border-color:  transparent transparent ' + bg + ' transparent;'}
          ${tooltipPosition == 'bottom' && (0, _styledComponents.css)`
					top: 100%;
					left: 50%;
					transform: translate(-50%, calc(-50% + 4px));
				`}
          ${tooltipPosition == 'right' && (0, _styledComponents.css)`
					top: 100%;
					left: 100%;
					transform: translate(calc(-50% + 4px), 50%);
				`}
          ${tooltipPosition == 'left' && (0, _styledComponents.css)`
					top: 50%;
					left: 0;
					transform: translate(calc(-50% - 4px), -40%);
				`}
          ${tooltipPosition == 'top' && (0, _styledComponents.css)`
					top: 0;
					left: 50%;
					transform: translate(-50%, calc(-100% + 4px));
				`}
      }
  `;
}}
`;